
import Vue from 'vue';
import { mapActions } from 'vuex';

import { BanniereApi } from '@/api/banniere';
import { Banniere } from '@/model/banniere';

import BannierePub from './banniere-pub.vue';

export default Vue.extend({
  name: 'HeaderTdb',
  components: {
    BannierePub
  },
  data () {
    return {
      loading: false,
      itemsBanniere: [] as Banniere[]
    };
  },
  created () {
    this.loading = true;
    Promise.all([BanniereApi.getAllBannieres(), this.loadCoursMarche()]).then(([bannieres]) => {
      this.itemsBanniere = bannieres;
    }).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions({
      loadCoursMarche: 'cours-marche/loadMarches'
    })
  }
});
